<template>
  <div class="progress-container payment-indicator">
    <div
      class="payment-indicator"
      :style="indicatorStyles"
      id="payment-indicator"
    >
      <span class="payment-indicator-text" :style="textStyles">
        {{ indicatorText }}
      </span>
      <button
				v-if="!isPending && !succeeded"
        type="button"
        @click.prevent="$emit('hide')"
        class="btn btn-primary btn-lg btn-block mb-2 d-flex justify-content-center align-items-center"
        :style="buttonStyles"
      >
        {{ $t("message.backToCheckout") }}
      </button>
    </div>
    <div class="indicator-footer">
      <span v-if="isPending">
        {{indicatorDescription}}.
      </span>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "PaymentIndicator",
  props: {
    isPending: {
      type: Boolean,
      required: false,
      default: true,
    },
    succeeded: {
      type: Boolean,
      required: true,
    },
    isPayLater: {
      type: Boolean,
      required: false,
      default: false,
    }
  },
  computed: {
    ...mapGetters(["desktopStyles"]),
    indicatorStyles() {
      if (this.isPending) {
        return {
          backgroundImage: `url(${require("../../../../assets/indicators/payment-processing-circle.gif")})`,
        };
      } else if (this.succeeded) {
        return {
          backgroundImage: `url(${require("../../../../assets/indicators/payment-success-circle.svg")}), url(${require("../../../../assets/indicators/payment-success-tick.svg")})`,
          backgroundPosition: "center 25px, center 72px",
        };
      } else {
        return {
          backgroundImage: `url(${require("../../../../assets/indicators/payment-failure-circle.svg")}), url(${require("../../../../assets/indicators/payment-failure-close.svg")})`,
          backgroundPosition: "center 25px, center 66px",
        };
      }
    },
    indicatorText() {      
      if(this.isPayLater)
      {
        return this.isPending
        ? this.$t("message.processingOrder")
        : this.succeeded
        ? this.$t("message.orderCompleted").concat('.')
        : this.$t("message.orderCouldNotBeProcessed").concat('.');
      }
      else
      {
      return this.isPending
        ? this.$t("message.processingPayment")
        : this.succeeded
        ? this.$t("message.paymentComplete").concat('.')
        : this.$t("message.paymentCouldNotBeProcessed").concat('.');
      }
    },
    indicatorDescription() {
      return this.isPayLater
        ? this.$t("message.pleaseDoNotRefreshYourBrowserWhileTheOrderIsBeingProcessed")
        : this.$t("message.pleaseDoNotRefreshYourBrowserWhilePaymentIsBeingProcessed");
    },
    textStyles() {
      const color = this.isPending
        ? "#0049CE"
        : this.succeeded
        ? "#00A806"
        : "#F44336";
      return { color, flex: "100% 1 0" };
    },
    buttonStyles() {
      return {
        ...this.desktopStyles.btn,
        ...this.desktopStyles.desktopPlaceOrderButton,
				marginTop: '25px',
        marginBottom: '-75px !important',
      };
    },
  },
};
</script>
